import { Link } from "react-router-dom";
import { Instagram, Mail, MapPin, Phone } from "lucide-react";
import { useLocale } from "../i18n/LocaleContext";
import { CATEGORIES } from "../data/treatments";

export function Footer() {
  const { t, link, lang } = useLocale();
  const year = new Date().getFullYear();

  return (
    <footer data-testid="site-footer" className="bg-imperium-brown text-imperium-white">
      <div className="mx-auto max-w-[1600px] px-6 py-20 sm:px-10 lg:px-16 lg:py-28">
        <div className="flex flex-col items-start gap-6 border-b border-imperium-champagne/20 pb-14">
          <img src="/assets/img/logo-emblem.png" alt="" className="h-16 w-auto opacity-90" />
          <p className="font-serif text-3xl tracking-[0.35em] text-imperium-champagne sm:text-4xl">IMPERIUM</p>
          <p className="text-[11px] font-label uppercase tracking-[0.4em] text-imperium-champagne/70">Beauty &amp; Wellness</p>
          <p className="text-sm text-imperium-white/60">{t("footer.tagline")}</p>
        </div>

        <div className="grid gap-12 py-14 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <p className="mb-6 text-[11px] font-label uppercase tracking-[0.3em] text-imperium-champagne/70">{t("footer.navTitle")}</p>
            <ul className="space-y-3">
              {["home", "treatments", "about", "studio", "contact"].map((k) => (
                <li key={k}>
                  <Link to={link(k)} data-testid={`footer-nav-${k}`} className="link-line text-sm text-imperium-white/80 transition-colors hover:text-imperium-champagne">
                    {t(`nav.${k}`)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="mb-6 text-[11px] font-label uppercase tracking-[0.3em] text-imperium-champagne/70">{t("footer.treatmentsTitle")}</p>
            <ul className="space-y-3">
              {CATEGORIES.map((cat) => (
                <li key={cat.key}>
                  <Link to={link("treatments", cat.slugs[lang])} data-testid={`footer-category-${cat.key}`} className="link-line text-sm text-imperium-white/80 transition-colors hover:text-imperium-champagne">
                    {cat.names[lang]}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="mb-6 text-[11px] font-label uppercase tracking-[0.3em] text-imperium-champagne/70">{t("footer.contactTitle")}</p>
            <ul className="space-y-4 text-sm text-imperium-white/80">
              <li className="flex items-start gap-3">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-imperium-champagne" />
                <span data-testid="footer-location">{t("footer.location")}</span>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="mt-0.5 h-4 w-4 shrink-0 text-imperium-champagne" />
                <a href="tel:+41786136096" data-testid="footer-phone" className="link-line transition-colors hover:text-imperium-champagne">+41 78 613 60 96</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="mt-0.5 h-4 w-4 shrink-0 text-imperium-champagne" />
                <a href="mailto:kontakt@imperium-wellness.ch" data-testid="footer-email-main" className="link-line transition-colors hover:text-imperium-champagne">kontakt@imperium-wellness.ch</a>
              </li>
              <li className="flex items-start gap-3">
                <Instagram className="mt-0.5 h-4 w-4 shrink-0 text-imperium-champagne" />
                <a href="https://www.instagram.com/imperiumbasel" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="link-line transition-colors hover:text-imperium-champagne">@Imperiumbasel</a>
              </li>
            </ul>
          </div>
          <div>
            <p className="mb-6 text-[11px] font-label uppercase tracking-[0.3em] text-imperium-champagne/70">{t("footer.legalTitle")}</p>
            <ul className="space-y-3">
              <li><Link to={link("impressum")} data-testid="footer-impressum" className="link-line text-sm text-imperium-white/80 transition-colors hover:text-imperium-champagne">{t("footer.impressum")}</Link></li>
              <li><Link to={link("privacy")} data-testid="footer-privacy" className="link-line text-sm text-imperium-white/80 transition-colors hover:text-imperium-champagne">{t("footer.privacy")}</Link></li>
            </ul>
            <p className="mt-8 text-sm text-imperium-white/50">
              <a href="https://www.imperium-wellness.ch" target="_blank" rel="noopener noreferrer" data-testid="footer-website" className="link-line transition-colors hover:text-imperium-champagne">www.imperium-wellness.ch</a>
            </p>
          </div>
        </div>

        <div className="flex flex-col gap-3 border-t border-imperium-champagne/20 pt-8 text-xs text-imperium-white/50 sm:flex-row sm:items-center sm:justify-between">
          <p data-testid="footer-copyright">© {year} IMPERIUM Beauty &amp; Wellness — Leidiane Alcântara. {t("footer.rights")}</p>
          <a href="https://alpenpro.agency/" target="_blank" rel="noopener noreferrer" data-testid="footer-agency-credit" className="link-line w-fit transition-colors hover:text-imperium-champagne">
            Website by Alpen Pro Agency
          </a>
          <p>Basel · Schweiz</p>
        </div>
      </div>
    </footer>
  );
}
